import { useCallback } from "react";
import { Invoice } from "@common/types/invoice";
import { useOverlays } from "contexts/OverlayContext";
import { InvoicesViewContext } from "contexts/InvoicesViewContext";
import { InvoicesDrillDownDrawer } from "./InvoicesDrillDownDrawer";
import { useStandaloneInvoicesView } from "./useStandaloneInvoicesView";
import {
    defaultInvoicesView,
    invoiceTemplateSourcePickerView,
} from "./views/defaultInvoiceViews";

// Global overlay wrapper around InvoicesDrillDownDrawer, for callers that
// don't already render their own local instance (e.g. the counterparty
// directory's Invoices column). Mirrors GlobalTransactionViewDrawer.
export const GlobalInvoicesDrilldownDrawer: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing, openOverlay } =
        useOverlays();
    const overlayInfo = getOverlayInfo("invoicesDrilldown");
    const contextValue = useStandaloneInvoicesView();
    const isSelectForTemplate = overlayInfo?.data?.selectForTemplate === true;

    const handleSelectInvoice = useCallback(
        (invoice: Invoice) => {
            openOverlay("nativeInvoiceDrawer", {
                createTemplate: true,
                invoiceId: invoice.id,
            });
        },
        [openOverlay],
    );

    const handleCreateBlankTemplate = useCallback(() => {
        openOverlay("nativeInvoiceDrawer", { createTemplate: true });
    }, [openOverlay]);

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <InvoicesViewContext.Provider value={contextValue}>
            <InvoicesDrillDownDrawer
                view={
                    isSelectForTemplate
                        ? invoiceTemplateSourcePickerView
                        : defaultInvoicesView
                }
                open={!overlayIsClosing}
                onClose={closeOverlay}
                parentFilters={overlayInfo.data.filters}
                selectForTemplate={isSelectForTemplate}
                onSelectInvoice={
                    isSelectForTemplate ? handleSelectInvoice : undefined
                }
                onCreateBlankTemplate={
                    isSelectForTemplate ? handleCreateBlankTemplate : undefined
                }
            />
        </InvoicesViewContext.Provider>
    );
};
